<div style="width: 100%; height: auto;">
    <video width="100%" height="auto" controls controlsList="nodownload">
        <source src="../../../../assets/media/Video/KIKCAD 2D Tutorial.mp4" type="video/mp4">
        Your browser does not support the video tag.
    </video>
</div>

<!-- <div>
    <iframe width="900" height="600" src="https://www.youtube.com/embed/yADS31U2JAw?rel=0" frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen></iframe>
</div> -->